import moment, { Moment } from "moment";
import { SocialPost } from "../../../cores/socialPost/interfaces/api/get-social-posts";

const STATUS_WAITING = 0;
const STATUS_PUBLISHED = 1;

/**
 * Momento a usar en el calendario:
 * - publicados → postAt
 * - programados / pending con scheduleDate → scheduleDate
 * - publish-now en curso (WAITING sin fechas) → createdAt
 */
export function getSocialPostCalendarMoment(post: SocialPost): Moment {
  const p = post.post;
  const scheduled = p.scheduleDate ? moment(p.scheduleDate) : moment.invalid();
  const posted = p.postAt ? moment(p.postAt) : moment.invalid();
  const created = p.createdAt ? moment(p.createdAt) : moment.invalid();

  if (p.status === STATUS_PUBLISHED) {
    if (posted.isValid()) return posted;
    if (scheduled.isValid()) return scheduled;
    return posted;
  }

  if (scheduled.isValid()) return scheduled;
  if (posted.isValid()) return posted;

  // Only pending/in-progress immediate posts — not failures.
  if (p.status === STATUS_WAITING && created.isValid()) {
    return created;
  }

  return moment.invalid();
}

/** Publish-now still uploading/publishing (no scheduleDate yet). */
export function isImmediatePublishingPost(post: SocialPost): boolean {
  const p = post.post;
  return (
    p.status === STATUS_WAITING &&
    !(p.scheduleDate && String(p.scheduleDate).trim()) &&
    !(p.postAt && String(p.postAt).trim())
  );
}
